import React from 'react';
import Styles from './space.module.css';

export default function Space({ prop, onDrop, onDragOver }) {
  return (
    <div
      className={Styles.space}
      onDrop={onDrop}
      onDragOver={onDragOver}
    >
      {prop}
    </div>
  );
}
